export default __webpack_public_path__ + "963022b.png";